import applyAxiosAuthentication from "@/compositions/useAxiosAuthentication";
import axios, { type AxiosResponse } from "axios";
import { DEFAULT_HEADERS } from "@/compositions/useAxios/data.ts";
import type { IResponse } from "@/api";
import type { MeteringCustomersApiResponse, MeteringCustomersRequest } from "@/features/metering/types";

const axiosInstance = axios.create();
applyAxiosAuthentication(axiosInstance);

const METERING_CUSTOMERS_PATH = "/metering/api/v1/metering/customers";

const respondSuccess = (response: AxiosResponse): IResponse => ({
  loadingIndicator: false,
  errorIndicator: false,
  status: response.status,
  headers: response.headers,
  data: response.data,
  raw: response
});

const respondFailure = ({ error }: { error: unknown }): IResponse => ({
  loadingIndicator: false,
  errorIndicator: true,
  error
});

export const fetchMeteringCustomers = (params?: MeteringCustomersRequest): Promise<IResponse> => {
  const url = `${import.meta.env.VITE_API_BASE_URL}${METERING_CUSTOMERS_PATH}`;
  const queryParams: Record<string, string | number> = {};

  if (params?.tSearch) queryParams.tSearch = params.tSearch;
  if (params?.page !== undefined) queryParams.page = params.page;
  if (params?.limit !== undefined) queryParams.limit = params.limit;

  return axiosInstance
    .get<MeteringCustomersApiResponse>(url, {
      params: queryParams,
      headers: {
        ...DEFAULT_HEADERS,
        "api-key": import.meta.env.VITE_TENANT_API_KEY
      }
    })
    .then(respondSuccess)
    .catch((error) => respondFailure({ error }));
};
